import { render } from "./DiagnosisRepairInfos.vue?vue&type=template&id=118e03a6&scoped=true&ts=true&lang=pug"
import script from "./DiagnosisRepairInfos.vue?vue&type=script&lang=ts"
export * from "./DiagnosisRepairInfos.vue?vue&type=script&lang=ts"

import "./DiagnosisRepairInfos.vue?vue&type=style&index=0&id=118e03a6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118e03a6"]])

export default __exports__